import { useNavigate } from 'react-router-dom'
import { Card, Button, Container, Row, Col } from 'react-bootstrap'
import { useAppSelector } from '../../redux/hooks';
import { selectAuthenticatedUser } from '../../redux/slices/auth.slice';
import './databasePage.css';
import artTypes from '../../components/ArtTypes';

const DatabasePage = () => {
    const { access_token } = useAppSelector(selectAuthenticatedUser);
    const navigate = useNavigate();

    return <>
        <Container>
            <Row>
                <Col>
                    {access_token && (
                        <div className="database-action-buttons">
                            {/* TODO: Implement Add Art functionality */}
                            {/* <Button variant="primary" size="sm">Add a New Art</Button> */}
                            
                            {/* TODO: Implement My Entries functionality */}
                            {/* <Button variant="primary" size="sm">My entries</Button> */}
                        </div>
                    )}
                    <div className="home-wrapper">
                        {artTypes.map((artType) => {
                            const isMovie = artType.type === 'movie';
                            const cardClass = `card-arttype ${!isMovie ? 'card-arttype-inactive' : ''}`;
                            
                            return (
                                <Card 
                                    className={cardClass} 
                                    key={artType.id} 
                                    onClick={isMovie ? () => navigate("/arts/"+artType.type) : undefined}
                                >
                                    <Card.Img src={artType.image} alt={artType.title} />
                                    <Card.Body>
                                        <Card.Title>{artType.title}</Card.Title>
                                        <Card.Subtitle className="home-owner">{artType.description}</Card.Subtitle>                                    
                                    </Card.Body>
                                    <Button 
                                        variant="primary" 
                                        size="sm" 
                                        href={isMovie ? "/arts/"+artType.type : undefined}
                                        disabled={!isMovie}
                                        className={!isMovie ? 'btn-inactive' : ''}
                                    >
                                        Browse {artType.title} database
                                    </Button>
                                </Card>
                            );
                        })}
                    </div>
                </Col>
            </Row>
        </Container>
    </>
}

export default DatabasePage;

